import React from 'react'
import { Form, Input, InputNumber, Checkbox, Row, Col, Alert } from 'antd'
import { RadioButtonF, SelectF } from '@/i2antdV5'

const FormItem = Form.Item
const { TextArea } = Input

// 规则类型选项
const ruleTypeOption = [
  { id: 'alert', value: '问题预警' },
  { id: 'completion_rate', value: '完成率预警' },
]

// 预警类型选项（事件/完成率都可以复用）
const typeOption = [
  { id: 1, value: '护理预警' },
  { id: 3, value: '到家预警' },
  { id: 4, value: '产康预警' },
  { id: 5, value: '客房预警' },
  { id: 6, value: '餐饮预警' },
  { id: 7, value: '监控预警' },
]

// 预警等级选项
const alertLevelOption = [
  { id: 1, value: '关注' },
  { id: 2, value: '提醒' },
  { id: 3, value: '紧急' },
  { id: 4, value: '特急' },
]

// 阈值类型选项
const thresholdTypeOption = [
  { id: 1, value: '时间型' },
  { id: 2, value: '百分比型' },
  { id: 3, value: '数量型' },
]

// 时间单位选项
const timeUnitOption = [
  { id: 'minute', value: '分钟' },
  { id: 'hour', value: '小时' },
  { id: 'day', value: '天' },
]

// 比较方式选项 - 时间型
const timeComparisonOption = [
  { id: '>=', value: '大于等于' },
  { id: '>', value: '大于' },
]

// 比较方式选项 - 百分比型
const percentageComparisonOption = [
  { id: '<=', value: '小于等于' },
  { id: '<', value: '小于' },
]

// 比较方式选项 - 数量型
const countComparisonOption = [
  { id: '>=', value: '大于等于' },
  { id: '>', value: '大于' },
  { id: '=', value: '等于' },
]

// 比较方式选项映射
const comparisonOptionMap = {
  1: timeComparisonOption,      // 时间型
  2: percentageComparisonOption, // 百分比型
  3: countComparisonOption,      // 数量型
}

// 通知方式选项
const noticeWayOption = [
  { id: 1, value: '钉钉' },
  { id: 2, value: '短信' },
  { id: 3, value: '站内消息' },
]


// 通知内容模板提示
const CONTENT_TEMPLATE_TIPS = `支持以下模板变量：
{alert_type} - 预警类型 {alert_type_name} - 预警类型名称 {customer_name} - 客户名称 {threshold_value} - 阈值数值 {unit} - 单位
{status} - 当前状态 {level_text} - 预警等级文本 {handler} - 负责人
{exceed_time} - 超时时间（分钟） {current_rate} - 当前完成率 {service_name} - 服务名称

提交例子： 
【护理预警】客户{customer_name}的{alert_type_name}预警已超过{threshold_value}{unit}未处理

示例通知内容：
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
【时间型阈值示例】
【护理预警】客户张小明的"宝宝发烧"预警已超过30分钟未处理，当前预警等级：紧急，请及时处理。

【百分比型阈值示例】
【护理预警】护理服务完成率仅为75%，低于阈值80%，请关注。

【数量型阈值示例】
【餐饮预警】当前积压未配餐数量为15条，超过阈值10条，预警等级：特急，请及时处理。
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`

class ServiceAlertsForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      roleOptions: [], // 角色选项列表
      userOptions: [], // 人员选项列表
      departmentOptions: [], // 部门选项列表
    }
  }

  componentDidMount() {
    // 初始化时加载所有通知对象选项
    this.loadAllNoticeObjectOptions()
  }

  componentDidUpdate(prevProps) {
    const { editingRule } = this.props
    // 如果编辑规则变化，重新加载所有选项
    if (editingRule?.id !== prevProps.editingRule?.id) {
      this.loadAllNoticeObjectOptions()
    }
  }

  /**
   * 阈值类型改变时的处理
   */
  handleThresholdTypeChange = (value) => {
    const { form } = this.props
    // 清空相关字段
    form.current.setFieldsValue({
      threshold_value: undefined,
      threshold_unit: undefined,
      comparison_operator: undefined,
    })
    
    // 根据阈值类型设置默认比较方式
    if (value === 1) {
      form.current.setFieldsValue({ comparison_operator: '>=' })
    } else if (value === 2) {
      form.current.setFieldsValue({ comparison_operator: '<=' })
    } else if (value === 3) {
      form.current.setFieldsValue({ comparison_operator: '>=' })
    }
  }

  /**
   * 获取通知对象选项（同步方法）
   */
  getNoticeObjectOptions = (type) => {
    // TODO: 实现数据加载逻辑
    // 这里先使用模拟数据，实际项目中需要调用相应的接口
    const mockOptions = {
      role: [
        { id: 'role_1', value: '管理员' },
        { id: 'role_2', value: '护理主管' },
        { id: 'role_3', value: '值班人员' },
        { id: 'role_4', value: '客服人员' },
        { id: 'role_5', value: '部门经理' },
      ],
      user: [
        { id: 'user_1', value: '张三' },
        { id: 'user_2', value: '李四' },
        { id: 'user_3', value: '王五' },
        { id: 'user_4', value: '赵六' },
        { id: 'user_5', value: '钱七' },
      ],
      department: [
        { id: 'dept_1', value: '护理部' },
        { id: 'dept_2', value: '客房部' },
        { id: 'dept_3', value: '餐饮部' },
        { id: 'dept_4', value: '产康部' },
        { id: 'dept_5', value: '到家服务部' },
      ],
    }
    
    return mockOptions[type] || []
  }

  /**
   * 加载所有通知对象选项（异步更新 state）
   */
  loadAllNoticeObjectOptions = () => {
    const roleOptions = this.getNoticeObjectOptions('role')
    const userOptions = this.getNoticeObjectOptions('user')
    const departmentOptions = this.getNoticeObjectOptions('department')
    
    this.setState({
      roleOptions,
      userOptions,
      departmentOptions,
    })
  }

  /**
   * 获取初始值
   */
  getInitialValues = () => {
    const { editingRule, defaultAlertType } = this.props

    if (editingRule) {
      // 编辑模式：使用传入的规则数据
      return {
        rule_type: editingRule.rule_type || 'alert',
        alert_type: editingRule.alert_type,
        alert_level: editingRule.alert_level,
        threshold_type: editingRule.threshold_type,
        threshold_value: editingRule.threshold_value,
        threshold_unit: editingRule.threshold_unit,
        comparison_operator: editingRule.comparison_operator || '>=',
        notice_way: editingRule.notice_way || [1],
        notice_roles: editingRule.notice_roles || [],
        notice_users: editingRule.notice_users || [],
        notice_departments: editingRule.notice_departments || [],
        notice_content: editingRule.notice_content,
      }
    }

    // 新建模式：使用默认值或预设的预警类型
    return {
      rule_type: 'alert',
      alert_type: defaultAlertType || 1,
      alert_level: 1,
      threshold_type: 1,
      comparison_operator: '>=',
      notice_way: [1], // 默认选择钉钉
      notice_roles: [],
      notice_users: [],
      notice_departments: [],
    }
  }

  render() {
    const { form, editingRule, defaultAlertType } = this.props
    const { roleOptions, userOptions, departmentOptions } = this.state

    return (
      <div>
        <Form
          ref={form}
          layout="vertical"
          initialValues={this.getInitialValues()}
          key={editingRule?.id || 'new'} // 使用 key 强制重新渲染表单
        >
          {/* 区块0：规则类型（用于区分问题预警 / 完成率预警） */}
          <Row gutter={16}>
            <Col span={24}>
              <FormItem
                label="规则类型"
                name="rule_type"
                rules={[{ required: true, message: '请选择规则类型' }]}
              >
                <RadioButtonF
                  modalProps={{ size: 'small' }}
                  options={ruleTypeOption}
                />
              </FormItem>
            </Col>
          </Row>

          {/* 区块1：基础配置 */}
          <Row gutter={16}>
            <Col span={14}>
              <FormItem
                label="预警类型"
                name="alert_type"
                rules={[{ required: true, message: '请选择预警类型' }]}
              >
                <RadioButtonF
                  modalProps={{ size: 'small' }}
                  options={typeOption}
                />
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem
                label="预警等级"
                name="alert_level"
                rules={[{ required: true, message: '请选择预警等级' }]}
              >
                <RadioButtonF
                  modalProps={{ size: 'small' }}
                  options={alertLevelOption}
                />
              </FormItem>
            </Col>
          </Row>

          {/* 区块2：阈值配置 */}
          <Row gutter={16}>
            <Col span={8}>
              <FormItem
                label="阈值类型"
                name="threshold_type"
                rules={[{ required: true, message: '请选择阈值类型' }]}
              >
                <RadioButtonF
                  modalProps={{ size: 'small' }}
                  options={thresholdTypeOption}
                  onChange={this.handleThresholdTypeChange}
                />
              </FormItem>
            </Col>
            <Col span={8}>
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) =>
                  prevValues.threshold_type !== currentValues.threshold_type
                }
              >
                {({ getFieldValue }) => {
                  const thresholdType = getFieldValue('threshold_type')
                  return (
                    <FormItem
                      label="阈值数值"
                      name="threshold_value"
                      rules={[
                        { required: true, message: '请输入阈值数值' },
                        {
                          validator: (_, value) => {
                            if (value === undefined || value === null || value === '') {
                              return Promise.reject(new Error('请输入阈值数值'))
                            }
                            if (thresholdType === 2 && (value < 0 || value > 100)) {
                              return Promise.reject(new Error('百分比范围应在0-100之间'))
                            }
                            if (value < 0) {
                              return Promise.reject(new Error('阈值数值不能小于0'))
                            }
                            return Promise.resolve()
                          },
                        },
                      ]}
                    >
                      <InputNumber
                        style={{ width: '100%' }}
                        placeholder="请输入阈值数值"
                        min={0}
                        max={thresholdType === 2 ? 100 : undefined}
                        precision={thresholdType === 2 ? 2 : 0}
                      />
                    </FormItem>
                  )
                }}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) =>
                  prevValues.threshold_type !== currentValues.threshold_type
                }
              >
                {({ getFieldValue }) => {
                  const thresholdType = getFieldValue('threshold_type')
                  if (thresholdType === 1) {
                    // 时间型：显示阈值单位
                    return (
                      <FormItem
                        label="阈值单位"
                        name="threshold_unit"
                        rules={[{ required: true, message: '请选择阈值单位' }]}
                      >
                        <SelectF
                          modalProps={{ placeholder: '请选择单位' }}
                          options={timeUnitOption}
                        />
                      </FormItem>
                    )
                  } else if (thresholdType !== undefined) {
                    // 百分比型或数量型：显示比较方式
                    return (
                      <FormItem
                        label="比较方式"
                        name="comparison_operator"
                        rules={[{ required: true, message: '请选择比较方式' }]}
                      >
                        <SelectF
                          modalProps={{ placeholder: '请选择比较方式' }}
                          options={comparisonOptionMap[thresholdType] || []}
                        />
                      </FormItem>
                    )
                  }
                  return null
                }}
              </Form.Item>
            </Col>
          </Row>

          {/* 时间型阈值需要单独显示比较方式 */}
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.threshold_type !== currentValues.threshold_type
            }
          >
            {({ getFieldValue }) => {
              const thresholdType = getFieldValue('threshold_type')
              if (thresholdType === 1) {
                return (
                  <Row gutter={16}>
                    <Col span={8}>
                      <FormItem
                        label="比较方式"
                        name="comparison_operator"
                        rules={[{ required: true, message: '请选择比较方式' }]}
                      >
                        <SelectF
                          modalProps={{ placeholder: '请选择比较方式' }}
                          options={comparisonOptionMap[thresholdType] || []}
                        />
                      </FormItem>
                    </Col>
                  </Row>
                )
              }
              return null
            }}
          </Form.Item>

          {/* 区块3：通知配置 */}
          <Row gutter={16}>
            <Col span={24}>
              <FormItem
                label="通知方式"
                name="notice_way"
                rules={[
                  { required: true, message: '请至少选择一种通知方式' },
                  {
                    validator: (_, value) => {
                      if (!value || value.length === 0) {
                        return Promise.reject(new Error('请至少选择一种通知方式'))
                      }
                      return Promise.resolve()
                    },
                  },
                ]}
              >
                <Checkbox.Group>
                  {noticeWayOption.map((item) => (
                    <Checkbox key={item.id} value={item.id}>
                      {item.value}
                    </Checkbox>
                  ))}
                </Checkbox.Group>
              </FormItem>
            </Col>
          </Row>

          {/* 通知对象配置 - 分为3个独立的多选 */}
          <Row gutter={16}>
            <Col span={24}>
              <FormItem
                label="通知角色"
                name="notice_roles"
                rules={[
                  {
                    validator: (_, value) => {
                      const { form } = this.props
                      const noticeUsers = form.current?.getFieldValue('notice_users') || []
                      const noticeDepartments = form.current?.getFieldValue('notice_departments') || []
                      if ((!value || value.length === 0) && noticeUsers.length === 0 && noticeDepartments.length === 0) {
                        return Promise.reject(new Error('请至少选择一种通知对象'))
                      }
                      return Promise.resolve()
                    },
                  },
                ]}
              >
                <SelectF
                  modalProps={{
                    mode: 'multiple',
                    placeholder: '请选择角色（可多选）',
                    allowClear: true,
                  }}
                  options={roleOptions}
                />
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem
                label="通知人员"
                name="notice_users"
                rules={[
                  {
                    validator: (_, value) => {
                      const { form } = this.props
                      const noticeRoles = form.current?.getFieldValue('notice_roles') || []
                      const noticeDepartments = form.current?.getFieldValue('notice_departments') || []
                      if ((!value || value.length === 0) && noticeRoles.length === 0 && noticeDepartments.length === 0) {
                        return Promise.reject(new Error('请至少选择一种通知对象'))
                      }
                      return Promise.resolve()
                    },
                  },
                ]}
              >
                <SelectF
                  modalProps={{
                    mode: 'multiple',
                    placeholder: '请选择人员（可多选）',
                    allowClear: true,
                  }}
                  options={userOptions}
                />
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem
                label="通知部门"
                name="notice_departments"
                rules={[
                  {
                    validator: (_, value) => {
                      const { form } = this.props
                      const noticeRoles = form.current?.getFieldValue('notice_roles') || []
                      const noticeUsers = form.current?.getFieldValue('notice_users') || []
                      if ((!value || value.length === 0) && noticeRoles.length === 0 && noticeUsers.length === 0) {
                        return Promise.reject(new Error('请至少选择一种通知对象'))
                      }
                      return Promise.resolve()
                    },
                  },
                ]}
              >
                <SelectF
                  modalProps={{
                    mode: 'multiple',
                    placeholder: '请选择部门（可多选）',
                    allowClear: true,
                  }}
                  options={departmentOptions}
                />
              </FormItem>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <FormItem
                label="通知内容"
                name="notice_content"
                rules={[
                  { required: true, message: '请输入通知内容' },
                  { max: 500, message: '通知内容不能超过500个字符' },
                ]}
                extra={
                  <Alert
                    message={
                      <div style={{ whiteSpace: 'pre-line', lineHeight: '1.8' }}>
                        {CONTENT_TEMPLATE_TIPS}
                      </div>
                    }
                    type="info"
                    showIcon
                    style={{ marginTop: 8, fontSize: '12px' }}
                  />
                }
              >
                <TextArea
                  rows={4}
                  placeholder="请输入通知内容，支持模板变量"
                  showCount
                  maxLength={500}
                />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

export default ServiceAlertsForm